export default "//file.bilionpass.com/japandx-portal/0.1.17/static/img/arrow-hr.fb911aaa-4166a7.svg";